import React from 'react';
import FunctionButtonsView from '../view/FunctionButtonsView';

const row = [
  { id: 'min', label: 'Min' },
  { id: 'max', label: 'Max' },
  { id: 'avg', label: 'Average' }
];

const FunctionButtonsEngine = ({
  disabledButtons,
  onClickButton = () => {}
}) => {
  row.forEach(oneButton => {
    if (disabledButtons.includes(oneButton.id)) {
      oneButton.disabled = true;
    } else {
      delete oneButton.disabled;
    }
  });
  const viewProps = {
    row,
    onClickButton
  };

  return <FunctionButtonsView {...viewProps} />;
};

export default FunctionButtonsEngine;
